import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`grid gap-x-2`};
  grid-template-columns: min-content auto;
`

export const InputWrapper = styled.div`
  position: relative;
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 3px;
`

export const CheckMark = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  pointer-events: none;
  opacity: 0;

  input:checked ~ & {
    opacity: 1;
  }
`

export const Input = styled.input`
  appearance: none;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 20%;
  border: solid 1px var(--color-gold-black);
  background-color: var(--color-white);

  ${Root}:hover & {
    background-color: var(--color-input-bg);
  }

  &:checked,
  ${Root}:hover &:checked,
  &:indeterminate,
  ${Root}:hover &:indeterminate {
    border-color: var(--color-gold);
    background-color: var(--color-gold);
  }

  &:focus {
    box-shadow: 0 0 0 3px var(--color-input-bg);
  }
`

export const Label = styled.label`
  user-select: none;

  a {
    color: plum;
    font-weight: 500;
  }
`
